export function formatAnalyticsDuration(seconds: number | null): string {
  if (seconds === null) return "—";
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return remainder === 0 ? `${hours}h` : `${hours}h ${remainder}m`;
}

export function formatAnalyticsLoc(value: number | null): string {
  return value === null ? "—" : value.toLocaleString();
}

export function weightedAnalyticsAverage(
  rows: Array<{ value: number | null; samples: number }>,
): number | null {
  const samples = rows.reduce((total, row) => total + row.samples, 0);
  if (samples === 0) return null;
  return Math.round(rows.reduce((total, row) => total + (row.value ?? 0) * row.samples, 0) / samples);
}

export function analyticsDurationBucketValue(distribution: { medianSeconds: number | null; samples: number }): number | null {
  return distribution.samples === 0 ? null : distribution.medianSeconds;
}

export function compareAnalyticsNullable(left: number | null, right: number | null): number {
  return (left ?? Number.NEGATIVE_INFINITY) - (right ?? Number.NEGATIVE_INFINITY);
}
